import React, { useEffect, useState } from 'react';
import styles from './ClinicsAndChains.module.scss'
import ClinicsTable from "../../../components/ClinicsTable/ClinicsTable";
import {$t} from "../../../helpers/translator";
import Loader from '../../../components/miscellaneous/Loader/Loader';

const AdminClinicsAndChains = (props) => {
    const [filters, setFilters] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setFilters(getFiltersFromQuery());
        setIsLoading(false);
    }, [])

    const getFiltersFromQuery = () => {
        let filters = {};
        let query = props.location.search;
        if (query) {
            query = query.substring(1);
            let queryArr = query.split('&');
            queryArr.forEach(item => {
                let key = item.split('=')[0];
                let value = item.split('=')[1];
                filters[key] = value;
            })
        }
        return filters;
    }

    return (
        <div className={styles.container}>
            {!isLoading ? <ClinicsTable filters={filters} header={$t('global.clinics.clinicsAndChains')} userType={5}/> : <Loader color="#ddd" />}
        </div>
    )
}

export default AdminClinicsAndChains;

